import { useState } from 'react'
import AdvancedFilters from './AdvancedFilters'
import AdvancedFiltersTrigger from './AdvancedFiltersTrigger'
import { useAdvancedFilters } from './filterUrl'
import { countVisibleFilters } from './presetFilters'

// The trigger + popover pair every listing page needs. Advanced filters live in
// the URL (useAdvancedFilters), so this reads and writes the same state as the
// page's chips row and list query without anything being passed between them.
// Presets stay page-owned: pass them through when the page has defaults.
// `hiddenFields` drops fields from the popover's field picker for pages where
// one cannot mean anything -- see AvailableCarsHeader.
export default function AdvancedFiltersControl({ entity, context = null, presets, setPresets, defaultPresets, hiddenFields, compact = true }) {
    const [isOpen, setIsOpen] = useState(false)
    const [advancedFilters, setAdvancedFilters] = useAdvancedFilters()
    return (
        <>
            <AdvancedFiltersTrigger
                compact={compact}
                count={countVisibleFilters(presets, advancedFilters)}
                onClick={() => setIsOpen(!isOpen)}
            />
            {isOpen && (
                <AdvancedFilters
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    entity={entity}
                    context={context}
                    activeFilters={advancedFilters}
                    onApply={(newFilters) => setAdvancedFilters(newFilters)}
                    presets={presets}
                    onPresetsChange={setPresets}
                    defaultPresets={defaultPresets}
                    hiddenFields={hiddenFields}
                />
            )}
        </>
    )
}
